import { useEffect, useState } from 'react'
import { getPendecy } from '../../../services/api'

const PendencyContainer = () => {
	const [pendencies, setPendencies] = useState()
	let pendencyTxt
	const translated = []

	useEffect(() => {
		;(async () => {
			const pendencyResponse = await getPendecy()
			setPendencies(pendencyResponse.data)
		})()
	}, [])

	const dict = {
		phones: 'Telefone',
		id_code: 'Cpf ou Cnpj',
		address: 'Endereço',
		postal_code: 'Cep',
	}
	if (pendencies) {
		for (let i = 0; i < pendencies.length; i++) {
			translated.push(dict[pendencies[i]])
		}

		if (pendencies.length === 1) {
			pendencyTxt = '1 pendência.'
		} else if (pendencies != 1) {
			pendencyTxt = `${pendencies.length} pendências.`
		}
	}
	return (
		<div className="pendencyContainer">
			{translated.length === 0 ? (
				<div>
					<label className="pendencyLabel">Você não possui pendências.</label>
				</div>
			) : (
				<>
					<div>
						<label className="pendencyLabel">Você possui </label>
						<span className="pendencyLabel">{pendencyTxt}</span>
					</div>
					<span className="pendencyText"> ({translated.join(', ')})</span>
				</>
			)}
		</div>
	)
}

export default PendencyContainer
